
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1129.3 750"}},[_c('path',{attrs:{"d":"M1129.4 70.4v-9c0-33.9-32.6-61.4-73-61.4H73C32.8 0 0 27.4 0 61.4v9.1l564.8 374.9z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M564.6 506.8a82.6 82.6 0 01-45.3-13.2L0 148.7v539.9C0 722.5 32.6 750 73 750h983.5c40.2 0 73-27.4 73-61.4V148.7L609.8 493.6a81.55 81.55 0 01-45.2 13.2z","fill":"currentColor"}})])
      }
    
      }
    